import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux'
import {
    Head,
    Tree,
    ProductFilterCreate,
    ProductFilterMove
} from "../../../components";
import {Paper} from "@mui/material";
import {Tooltip} from "@mui/material";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import { treeAction } from './../../../actions'
import {FETCH_NODES, TOGGLE_CHECKED, TOGGLE_EXPANDED} from "../../../types";
import {Link} from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import {TextField} from "@mui/material";
import Grid from "@mui/material/Grid";

const ProductFilter = ({fetchNodes, tree}) => {

    const dispatch = useDispatch();


    const [form, setForm] = useState({})

    useEffect(() => {
        dispatch({type: TOGGLE_CHECKED, payload: []});
        dispatch({type: TOGGLE_EXPANDED, payload: []});
        dispatch({type: FETCH_NODES, payload: []});
    }, []);


    useEffect(() => {
        handleRequest();
    }, [form]);

    const handleChangeElement = (event) => {
        let frm = {...form};
        frm[event.target.name] = event.target.value;
        setForm(frm);
    };



    const handleRequest = () => {
        fetchNodes({
            term: form.title ? form.title : ''
        })
    }

    const expandScrolling = (expanded, nodes) => {

        nodes.map((node) => {
            expanded.push(node.id);
            expandScrolling(expanded,node.children);
        });

        return expanded;
    }

    const handleToggleExpand = () => {

        if (tree.expanded.length === 0) {
            dispatch({type: TOGGLE_EXPANDED, payload: expandScrolling(tree.expanded, tree.nodes) });
        } else {
            dispatch({type: TOGGLE_EXPANDED, payload: []});
        }

    }

    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'فیلترهای دلخواه فروشگاه', 'description': 'فیلترها در صفحه فروشگاه قرار داده میشوند' }} />
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <ProductFilterCreate checked={tree.checked} reload={() => handleRequest()} />
                {tree.checked.length === 1 && <Tooltip title="ویرایش" component={Link} to={'/product/filter/'+ tree.checked + '/edit'}>
                    <IconButton>
                        <EditIcon />
                    </IconButton>
                </Tooltip>}
                {tree.checked.length === 1 && <ProductFilterMove checked={tree.checked} reload={() => handleRequest()} />}
                <Tooltip title="باز و بسته کردن">
                    <IconButton onClick={() => handleToggleExpand()}>
                        <AspectRatioIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="سینک">
                    <IconButton onClick={() => handleRequest()} >
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <Paper elevation={1}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                style={{ marginTop: '25px'}}
                                label="نام"
                                variant="outlined"
                                margin='dense'
                                fullWidth
                                value={form.title}
                                name='title'
                                onChange={handleChangeElement}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                placeholder={'جستجو کنید'}
                                autoComplete={"off"}
                            />
                        </Grid>
                    </Grid>
                </Container>
                <Tree nodes={tree.nodes} />
            </Paper>
        </Container>

    );
}


const mapStateToProps = state => ({
    tree: state.treeReducer
});

const mapDispatchToProps = (dispatch) => ({
    fetchNodes: (object) => {
        dispatch(treeAction.filters(object))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductFilter)
